<script lang="ts">

  import { browser } from "$app/environment"
  import { goto } from "$app/navigation"
  import { appStore } from "$lib/stores/app-store.svelte"

  const { children } = $props()

  $effect.pre(() => {
    if (browser && appStore.user == null) {
      goto("/auth/login", { replaceState: true })
    }
  })

</script>

{#if appStore.user != null}
  {@render children()}
{/if}
